"use client";

import { ErrorCard } from "../ErrorCard";

interface ErrorsTabProps {
  context: Record<string, unknown>;
}

export function ErrorsTab({ context }: ErrorsTabProps) {
  // Find all error fields in context
  const errorFields = Object.entries(context).filter(
    ([key, value]) =>
      key.toLowerCase().includes("error") &&
      value !== null &&
      value !== undefined,
  );

  const hasErrors = errorFields.length > 0;

  return (
    <div className="space-y-4 p-4">
      <div>
        <h3 className="text-sm font-semibold text-gray-700 mb-2">
          Error Inspector
        </h3>
        <p className="text-sm text-gray-600 mb-4">
          View all errors saved in context during flow execution
        </p>
      </div>

      {!hasErrors ? (
        <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center">
          <div className="text-green-600 text-lg mb-2">✓</div>
          <div className="text-sm font-medium text-green-900">No Errors</div>
          <div className="text-xs text-green-700 mt-1">
            All actors executed successfully
          </div>
        </div>
      ) : (
        <div className="space-y-4">
          {errorFields.map(([fieldName, errorValue]) => (
            <ErrorCard
              key={fieldName}
              fieldName={fieldName}
              error={errorValue}
            />
          ))}
        </div>
      )}
    </div>
  );
}
